module.exports = __webpack_public_path__ + "static/media/main_large_3.e01f9caf.png";